<template>
  <div class="main-container">
    <h3>请设置新密码</h3>    
    <van-form @submit="onSubmit">
      <van-field
        v-model="Form.username"
        label="用户名"
        :placeholder="userinfo.username"
        readonly
      />
      <van-field
        v-model="Form.oldpassword"
        clearable
        type="password"
        label="旧密码"
        placeholder="请输入旧密码"
        :rules="[{ required: true, message: '请输入正确的旧密码' }]"
      />
      <van-field
        v-model="Form.password"
        clearable
        label="新密码"
        placeholder="最少6位,建议英文、数字、下划线组合"
        :rules="[{ required: true, pattern: /^[A-Za-z\d$@!%*#?&.-]{6,}$/, message: '最少6位,建议英文、数字、下划线组合' }]"
      />
      <div style="padding: 16px;">
        <van-button round block type="primary" native-type="submit">
          提交
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import {
  mapGetters
} from 'vuex'
export default {
  data () {
    return {
      Form: {
        username: '',
        oldpassword: '',
        password: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      userinfo: 'user/userinfo'
    })
  },
  methods: {
    onSubmit (formName) {
      this.Form.username = this.userinfo.username
      this.$api.user.changepassword(this.Form)
        .then((res) => {
          if (res.data.code === 200) {
            this.$toast.success('密码修改成功！')
            this.$router.push({ name: 'Refresh' })
          } else {
            this.$notify(res.data.message)
          }
        })
        .catch(() => {
          return false
        })
    }
  }
}
</script>
